const _ = require('lodash');

function getAllServicesFlat(categories) {
  const services = _.flatMap(categories, (category) => {
    return category.services;
  });
  return {
    ...services,
  };
}

function getServiceByPathName(categoriesWithPathName, pathName) {
  const services = getAllServicesFlat(categoriesWithPathName);
  return _.find(services, { pathName });
}

function getCategoryByPathName(categoriesWithPathName, pathName) {
  return _.find(categoriesWithPathName, { pathName });
}

function getCategoriesOrServiceDisplayNameByKey(key) {
  return CATEGORIES_AND_SERVICES_DISPLAY_KEY_TO_PATH_PARAM_MAP[key];
}

const EDITOR_X_SERVICE_ID = 'e86b0978-352a-44d4-a89a-50e5a66d3b6f';

const CATEGORIES_AND_SERVICES_DISPLAY_KEY_TO_PATH_PARAM_MAP = {
  webdesign: 'web-design',
  classicwebsite: 'classic-website',
  advancedwebsite: 'advanced-website',
  redesignsite: 'redesign-website',
  smalltasks: 'small-tasks',
  domain: 'connect-domain',
  updates: 'site-updates',
  movesite: 'migrate-website',
  mobilesite: 'mobile-website',
  siteguidance: 'website-guidance',
  installapps: 'install-apps',
  email: 'custom-email',
  pixel: 'facebook-pixel',
  analytics: 'google-analytics',
  onlinestore: 'online-store',
  ecommercesite: 'ecommerce-website-design',
  advancedstore: 'advanced-store-capabilities',
  storesettings: 'store-settings',
  storeopt: 'store-optimization',
  webdev: 'web-developer',
  codingguidance: 'coding-guidance',
  customsitefunctionalities: 'custom-site-functionalities',
  thirdpartyservices: 'third-party-services',
  contentwithdatabase: 'content-with-database',
  custominputforms: 'custom-input-forms',
  customdesign: 'custom-design-and-behavior',
  marketingandpromoting: 'marketing-promoting',
  seo: 'seo-services',
  ads: 'ad-setup',
  written: 'content-writer',
  emailmarketing: 'email-marketing',
  graphicdesign: 'graphic-designer',
  logo: 'logo-design-services',
  editimage: 'edit-image',
  visuals: 'visual-content',
  branddev: 'brand-development',
  photos: 'professional-photography',
  accessibility: 'accessibility',
  'restaurant-menu-setup': 'restaurant-menu-setup',
  intro: 'intro',
  'intro-simple': 'intro-simple',
  'intro-advanced': 'intro-advanced',
  'intro-ecomm': 'intro-ecomm',
  other: 'other',
  'editor-x': 'editor-x',
  'editor-x-build-from-scratch': 'editor-x-build-from-scratch',
  'editor-x-redesign-my-site': 'editor-x-redesign-my-site',
  'editor-x-customize-breakpoints': 'editor-x-customize-breakpoints',
  'editor-x-build-my-design': 'editor-x-build-my-design',
};

const innerAndServicesTypeToServiceIdMap = [
  {
    displayKey: 'classicwebsite',
    innerType: 2,
    serviceType: 2,
    id: 'a276b167-e038-4545-9c33-b859e3568a9e',
  },
  {
    displayKey: 'advancedwebsite',
    innerType: 1,
    serviceType: 2,
    id: '09569b86-c8fc-4d02-99ce-a452f434e4d9',
  },
  {
    displayKey: 'redesignsite',
    innerType: 3,
    serviceType: 2,
    id: 'ba0f47b7-efb7-4325-bcb8-fee61e0bc834',
  },
  {
    displayKey: 'movesite',
    innerType: 4,
    serviceType: 2,
    id: 'ebd0ba79-eb2d-499e-b6cd-3e93a78d518f',
  },
  {
    displayKey: 'mobilesite',
    innerType: 1,
    serviceType: 4,
    id: 'd6865737-811e-4765-9a04-7b0b458e1130',
  },
  {
    displayKey: 'editor-x-build-from-scratch',
    innerType: 15,
    serviceType: 2,
    id: 'e86b0978-352a-44d4-a89a-50e5a66d3b6f',
  },
  {
    displayKey: 'domain',
    innerType: 4,
    serviceType: 4,
    id: '07a0582a-5eff-48e9-a1ef-d0a0e73c68ec',
  },
  {
    displayKey: 'updates',
    innerType: 3,
    serviceType: 4,
    id: 'be4031f9-16b5-49ad-8f91-32a2ddd8485f',
  },
  {
    displayKey: 'siteguidance',
    innerType: 5,
    serviceType: 2,
    id: '22b2cc0f-39b3-4800-abfc-d451b689d56f',
  },
  {
    displayKey: 'installapps',
    innerType: 2,
    serviceType: 4,
    id: 'd5108a1f-5ea1-4eca-b63e-963a9362336b',
  },
  {
    displayKey: 'email',
    innerType: 5,
    serviceType: 4,
    id: '5b8d16f0-7858-41a4-a9df-0a8a11ecd662',
  },
  {
    displayKey: 'pixel',
    innerType: 4,
    serviceType: 6,
    id: 'ab93767c-3e26-4b19-819b-abe0a7b1353e',
  },
  {
    displayKey: 'analytics',
    innerType: 5,
    serviceType: 6,
    id: '9de611fe-524b-4dca-b5c1-7d73f8baa51e',
  },
  {
    displayKey: 'accessibility',
    innerType: 6,
    serviceType: 4,
    id: '3e57a1f2-49e0-4394-b656-65206fca7161',
  },
  {
    displayKey: 'restaurant-menu-setup',
    innerType: 7,
    serviceType: 4,
    id: '05ba1c0d-b1c7-45ed-82ad-6dda69aeb2e5',
  },
  {
    displayKey: 'ecommercesite',
    innerType: 1,
    serviceType: 3,
    id: '2f6dcd2b-9dbd-41e7-a5f9-338c3601ff0e',
  },
  {
    displayKey: 'advancedstore',
    innerType: 2,
    serviceType: 3,
    id: 'e3607ea3-fe0a-4dc9-a90a-4e9d56c288b9',
  },
  {
    displayKey: 'storesettings',
    innerType: 4,
    serviceType: 3,
    id: '99b8ae14-292b-49ab-9f63-8e935864ab58',
  },
  {
    displayKey: 'storeopt',
    innerType: 3,
    serviceType: 3,
    id: '0913d834-654c-4400-b6ca-78679aff41a2',
  },
  {
    displayKey: 'codingguidance',
    innerType: 7,
    serviceType: 7,
    id: '6ddd5415-76de-423f-b518-8ec62c1e2edf',
  },
  {
    displayKey: 'customsitefunctionalities',
    innerType: 1,
    serviceType: 7,
    id: '5fd8a301-2a36-40b4-88b8-bbf3efe5cb41',
  },
  {
    displayKey: 'thirdpartyservices',
    innerType: 3,
    serviceType: 7,
    id: '6adcdfa0-0743-48df-a6ef-ee3a7df7a700',
  },
  {
    displayKey: 'contentwithdatabase',
    innerType: 4,
    serviceType: 7,
    id: 'bc892681-b108-4ea8-b04c-c40b6bd52694',
  },
  {
    displayKey: 'custominputforms',
    innerType: 5,
    serviceType: 7,
    id: '1f1e375c-6583-4054-84b0-4fa7160197b7',
  },
  {
    displayKey: 'customdesign',
    innerType: 6,
    serviceType: 7,
    id: 'df4d93c1-a4b9-44e0-9482-c8732db7eec7',
  },
  {
    displayKey: 'seo',
    innerType: 1,
    serviceType: 6,
    id: 'e5a2bfbf-0be2-45da-855d-519ec6e4015c',
  },
  {
    displayKey: 'ads',
    innerType: 2,
    serviceType: 6,
    id: '3d583c34-8d50-4b17-9859-0649bb2b557f',
  },
  {
    displayKey: 'written',
    innerType: 3,
    serviceType: 5,
    id: '89de24f9-ccf7-4c0c-b769-3ddb0f042a7b',
  },
  {
    displayKey: 'emailmarketing',
    innerType: 3,
    serviceType: 6,
    id: '7390abbb-b278-470f-83be-6d85bcccfb5b',
  },
  {
    displayKey: 'logo',
    innerType: 6,
    serviceType: 5,
    id: 'da660657-e255-4f72-ba03-c7cac757bce3',
  },
  {
    displayKey: 'editimage',
    innerType: 5,
    serviceType: 5,
    id: 'ec97a8c1-2f64-4b6e-827b-4fcbc976c9f9',
  },
  {
    displayKey: 'visuals',
    innerType: 2,
    serviceType: 5,
    id: '6d370fae-2896-469b-9c8f-11f8a39d508a',
  },
  {
    displayKey: 'branddev',
    innerType: 1,
    serviceType: 5,
    id: '40f83a36-5853-434d-b3f1-2a41f4de70dd',
  },
  {
    displayKey: 'photos',
    innerType: 4,
    serviceType: 5,
    id: '90079751-717b-4c0e-83fa-3500a57c24f8',
  },
  // hidden services
  {
    displayKey: 'mobile-app',
    innerType: 19,
    serviceType: 2,
    id: '0673d5d7-ac13-424a-a930-d623f82e7c9b',
  },
  {
    id: '299c212b-0006-4bef-a657-285bf33df364',
    displayKey: 'add-cross-selling',
    innerType: 8,
    serviceType: 7,
  },
  {
    id: 'f547ccc2-b6a8-45a9-8fa2-a50dcd03567e',
    displayKey: 'quick-code-solutions',
    innerType: 9,
    serviceType: 7,
  },
  {
    id: '44de4271-23ee-4d14-b109-2b609c331645',
    displayKey: 'professional-translation',
    innerType: 8,
    serviceType: 6,
  },
  {
    id: '53aae7e4-76f0-4562-8a77-4e5ef51931bb',
    displayKey: 'seo-consultation-call',
    innerType: 6,
    serviceType: 6,
  },
  {
    id: 'a994d2f1-227b-4f2d-b9d3-f892a9532acc',
    displayKey: 'marketing-and-promoting',
    innerType: 7,
    serviceType: 6,
  },
  {
    id: '98040325-a3f8-43ac-b21f-dd5a98841615',
    displayKey: 'eCommerce-Consultation-Call',
    innerType: 5,
    serviceType: 3,
  },
  {
    id: '006ee42f-3904-40fe-ae36-2e9c0233964f',
    displayKey: 'editor-x-redesign-my-site',
    innerType: 16,
    serviceType: 2,
  },
  {
    id: '09473474-4fd4-44e0-a7c5-1d0ad7dc3b03',
    displayKey: 'difm_complex_no_maintenance',
    innerType: 10,
    serviceType: 2,
  },
  {
    id: '2b3ed6cf-a70a-4e35-9990-003ce9db0f2b',
    displayKey: 'difm_simple_with_maintenance',
    innerType: 7,
    serviceType: 2,
  },
  {
    id: '4b43e59a-2440-492b-8fb4-1c71c410640f',
    displayKey: 'difm_complex_with_maintenance',
    innerType: 11,
    serviceType: 2,
  },
  {
    id: '6f88d2f6-0601-4511-b2cd-75a40f569d7d',
    displayKey: 'webdesign-consultation-call',
    innerType: 12,
    serviceType: 2,
  },
  {
    id: '76e2b971-4191-4489-bfb2-17709bcf5048',
    displayKey: 'editor-x-customize-breakpoints',
    innerType: 17,
    serviceType: 2,
  },
  {
    id: '98e3b8a6-fa61-4b16-8998-b1e2520a440c',
    displayKey: 'difm_simple_no_maintenance',
    innerType: 6,
    serviceType: 2,
  },
  {
    id: 'd75df0dc-30b6-4528-85cc-61af5220f382',
    displayKey: 'wow-web-services',
    innerType: 14,
    serviceType: 2,
  },
  {
    id: 'd8fa0768-101e-4fd3-ab2a-89d9492ce847',
    displayKey: 'difm_medium_no_maintenance',
    innerType: 8,
    serviceType: 2,
  },
  {
    id: 'ea52b84e-6070-4e42-87d8-c4572eab2131',
    displayKey: 'difm_medium_with_maintenance',
    innerType: 9,
    serviceType: 2,
  },
  {
    id: 'f7ca9ab7-2cc8-403b-b155-6dc41d3b2974',
    displayKey: 'editor-x-build-my-design',
    innerType: 18,
    serviceType: 2,
  },
  {
    id: 'f69a13ab-820e-4ccd-ba8c-560c960a5dc7',
    displayKey: 'bookings-consultation-call',
    innerType: 13,
    serviceType: 2,
  },
];

const deepLinkToServicePathNameMap = {
  'editor-x': 'editor-x',
  intro: 'intro',
  'small-tasks': 'small-tasks',
  ecomm: 'online-store',
  general_corvid_Menu: 'web-developer',
  velo: 'web-developer',
  generalSEO: 'marketing-promoting',
  promote: 'marketing-promoting',
  SEOWizard: 'marketing-promoting',
  'graphic-design': 'web-design',
  webdesign: 'web-design',
};

const isDeepLinkForCategories = ({ serviceType, innerType, entry }) => {
  if (serviceType === 1 && innerType === 1 && entry) {
    return deepLinkToServicePathNameMap[entry];
  }
  return false;
};

const additionalHiddenCategories = [
  {
    displayKey: 'editor-x',
    id: '00000000-0000-0000-0000-000000000000',
    pathName: 'editor-x',
    services: [
      {
        displayKey: 'editor-x-build-from-scratch',
        hidden: false,
        id: 'e86b0978-352a-44d4-a89a-50e5a66d3b6f',
        pathName: 'editor-x-build-from-scratch',
      },
      {
        displayKey: 'editor-x-redesign-my-site',
        hidden: false,
        id: '006ee42f-3904-40fe-ae36-2e9c0233964f',
        pathName: 'editor-x-redesign-my-site',
      },
      {
        displayKey: 'editor-x-customize-breakpoints',
        hidden: false,
        id: '76e2b971-4191-4489-bfb2-17709bcf5048',
        pathName: 'editor-x-customize-breakpoints',
      },
      {
        displayKey: 'editor-x-build-my-design',
        hidden: false,
        id: 'f7ca9ab7-2cc8-403b-b155-6dc41d3b2974',
        pathName: 'editor-x-build-my-design',
      },
    ],
  },
  {
    displayKey: 'intro',
    id: '00000000-0000-0000-0000-000000000001',
    pathName: 'intro',
    services: [
      {
        displayKey: 'intro-simple',
        hidden: false,
        showDescription: true,
        id: 'a276b167-e038-4545-9c33-b859e3568a9e',
        pathName: 'intro-simple',
      },
      {
        displayKey: 'intro-advanced',
        hidden: false,
        showDescription: true,
        id: '09569b86-c8fc-4d02-99ce-a452f434e4d9',
        pathName: 'intro-advanced',
      },
      {
        displayKey: 'intro-ecomm',
        hidden: false,
        showDescription: true,
        id: '2f6dcd2b-9dbd-41e7-a5f9-338c3601ff0e',
        pathName: 'intro-ecomm',
      },
      {
        displayKey: 'other',
        hidden: false,
        showDescription: true,
        id: 'a276b167-e038-4545-9c33-b859e3568a9e',
        pathName: 'other',
      },
    ],
  },
];

module.exports = {
  getAllServicesFlat,
  getServiceByPathName,
  getCategoryByPathName,
  getCategoriesOrServiceDisplayNameByKey,
  isDeepLinkForCategories,
  CATEGORIES_AND_SERVICES_DISPLAY_KEY_TO_PATH_PARAM_MAP,
  innerAndServicesTypeToServiceIdMap,
  additionalHiddenCategories,
  EDITOR_X_SERVICE_ID,
};
